<p-multiSelect
  [options]="items"
  [(ngModel)]="selectedItems"
  appendTo="body"
  placeholder="Izaberite vozila"
  (onChange)="selectedItemsOnChange()"
></p-multiSelect>
